import script from "./ArtistDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtistDetail.vue?vue&type=script&setup=true&lang=js"

import "./ArtistDetail.vue?vue&type=style&index=0&id=153703c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153703c6"]])

export default __exports__